import Button, { EButtonColor, EButtonVariant } from "components/elements/Button";
import I18n from "components/materials/I18n";
import classes from "./classes.module.scss";
import { useCallback } from "react";
import Form, { useForm } from "components/materials/Form";
import { TextArea } from "components/materials/Form/TextAreaElement";
import CommentRequestResource from "common/resources/Project/Config/Forum/Comment/CommentRequestResource";
import { container } from "tsyringe";
import { useProjectId } from "hooks/useProjectId";
import { usePostId } from "hooks/usePostId";
import CommentResponseResource from "common/resources/Project/Config/Forum/Comment/CommentResponseResource";
import CommentService from "services/projects/CommentService";

type IProps = {
	comment: Pick<CommentResponseResource, "id">;
	onCreated: (comment: CommentResponseResource) => void;
	onCancel: () => void;
};

const commentService = container.resolve(CommentService);

export default function CommentReplyForm(props: IProps) {
	const { projectId } = useProjectId();
	const { postId } = usePostId();
	const { errors, handleError, clearErrors } = useForm();

	const onCreateComment = useCallback(
		(formData: { [key: string]: unknown }) => {
			clearErrors();

			const commentRequestResource = CommentRequestResource.hydrate<CommentRequestResource>({
				text: formData["text"] as string,
			});

			commentRequestResource
				.validateOrReject()
				.then(() => {
					commentService.reply(projectId, postId, props.comment.id, commentRequestResource).then(props.onCreated).catch(handleError);
				})
				.catch(handleError);
		},
		[clearErrors, handleError, postId, projectId, props.comment.id, props.onCreated],
	);

	return (
		<Form onSubmit={onCreateComment} errors={errors} className={classes["root"]}>
			<div className={classes["inputs-container"]}>
				<TextArea name="text" required placeholder={I18n.asset.pages.post.comment.reply.your_reply} className={classes["input"]} />
			</div>

			<div className={classes["buttons-container"]}>
				<Button variant={EButtonVariant.TEXT} color={EButtonColor.PRIMARY} onClick={props.onCancel}>
					{I18n.asset.common.cancel}
				</Button>
				<Button type="submit" variant={EButtonVariant.CONTAINED} color={EButtonColor.PRIMARY}>
					{I18n.asset.pages.post.comment.reply.submit}
				</Button>
			</div>
		</Form>
	);
}
